import gql from 'graphql-tag';

export default gql`
    query GetStagesForJobLog($jobId: Int, $isGrouped: String) {
        getStagesForJobLog(jobId: $jobId, isGrouped: $isGrouped) {
            index
            stageIds
            stageDesc
        }
    }
`;
